var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLogin)?_c('div',{attrs:{"id":"user"}},[_c('div',{staticClass:"l"},[_c('Left')],1),_c('div',{staticClass:"c"},[_c('Router-view')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }